// DO NOT CHANGE constant value, because of publisher using
const prefix = 'custom-injection';

export const INLINE_CHANNEL_INFO_ID = `${prefix}-inline-channel-info`;
export const PLAYER_PAGE_TITLE_INFO_ID = `${prefix}-player-page-title-info`;
export const PLAYER_PAGE_ADDITIONAL_TITLE_INFO_ID = `${prefix}-player-page-additional-title-info`;
export const PLAYER_PAGE_DESCRIPTION_ID = `${prefix}-player-page-description`;
export const SEARCH_TOP_BLOCK_ID = `${prefix}-search-top-block`;
export const SEARCH_BOTTOM_BLOCK_ID = `${prefix}-search-bottom-block`;
export const SEARCH_GEN_AI_AD_BLOCK_ID = `${prefix}-search-gen-ai-ad-block`; // added for internal usage LP-6412
